// JustEasySEO — Merk-logo als SVG-componenten (M144 Fase 1).
// Varianten: `horizontal` (beeldmerk + woordmerk), `mark` (los beeldmerk),
// `mono` (monochroom voor plaatsen zonder kleur). Geen PNG-import.
// Icoon: zacht afgerond petrol-vierkant met witte J-vorm die als vinkje
// eindigt + klein abrikoos-eindpunt.
import React from "react";

const PETROL = "#087F8C";
const APRICOT = "#F4B183";
const INK = "#172C32";
const WHITE = "#FFFFFF";

function Mark({ size = 32, mono = false }) {
  const bg = mono ? INK : PETROL;
  const dot = mono ? WHITE : APRICOT;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
          className="shrink-0">
      <rect width="32" height="32" rx="8" fill={bg} />
      {/* J-vorm die eindigt als vinkje: verticale poot + curve + korte
          opwaartse tik. */}
      <path d="M20 7 V16 C20 20.4183 16.4183 24 12 24 C 9.7909 24 8 22.2091 8 20"
             stroke={WHITE} strokeWidth="3" strokeLinecap="round"
             fill="none" />
      <path d="M11.5 20.5 L15 24 L19 19"
             stroke={WHITE} strokeWidth="3" strokeLinecap="round"
             strokeLinejoin="round" fill="none" opacity="0.95" />
      <circle cx="20" cy="7" r="2.2" fill={dot} />
    </svg>
  );
}

function Wordmark({ mono = false, size = 20 }) {
  const primary = mono ? INK : INK;
  const secondary = mono ? INK : PETROL;
  return (
    <span
      className="font-display font-bold tracking-tight"
      style={{
        fontSize: `${size}px`,
        letterSpacing: "-0.01em",
        color: primary,
        lineHeight: 1,
      }}
    >
      JustEasy<span style={{ color: secondary }}>SEO</span>
    </span>
  );
}

export function Logo({ variant = "horizontal", size = 32, mono = false,
                        showTagline = false, className = "" }) {
  const wordSize = Math.round(size * 0.62);
  if (variant === "mark") {
    return (
      <span className={className} data-testid="logo-mark">
        <Mark size={size} mono={mono} />
      </span>
    );
  }
  if (variant === "mono") {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`}
             data-testid="logo-mono">
        <Mark size={size} mono />
        <Wordmark mono size={wordSize} />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}
           data-testid="logo-horizontal">
      <Mark size={size} mono={mono} />
      <span className="inline-flex flex-col leading-tight">
        <Wordmark mono={mono} size={wordSize} />
        {showTagline && (
          <span className="text-[10px] text-text-muted font-medium mt-0.5"
                 style={{ letterSpacing: "0.02em" }}>
            SEO zonder gedoe.
          </span>
        )}
      </span>
    </span>
  );
}

export default Logo;
